import { create } from 'zustand';

interface SwUpdateState {
  updateAvailable: boolean;
  updateSW: (() => Promise<void>) | null;
  setUpdateAvailable: (available: boolean) => void;
  setUpdateSW: (fn: (() => Promise<void>) | null) => void;
}

export const useSwUpdateStore = create<SwUpdateState>((set) => ({
  updateAvailable: false,
  updateSW: null,
  setUpdateAvailable: (available) => set({ updateAvailable: available }),
  setUpdateSW: (fn) => set({ updateSW: fn }),
}));
